import clsx from 'clsx'
import React from 'react'
import { useSelector } from 'react-redux'
import { Button, Icon, Input } from '../../components'

const CustomToken = ({ value, setValue, inPopover, onAdd }) => {
   const isDarkTheme = useSelector(state => state.theme)

   return (
      <div
         className={clsx(
            'ExchangeSettings__custom-token',
            inPopover && 'ExchangeSettings__custom-token--popover'
         )}
      >
         <h3 className="ExchangeSettings__custom-token-heading">
            <Icon name="warning" /> Warning
         </h3>
         <p className="ExchangeSettings__custom-token-text">
            This token is not Whitelisted on WSNS app. By adding it as a custom
            token, you confirm that all further interaction with it are at your
            own risk
         </p>
         <label className="ExchangeSettings__custom-token-label">
            Token Address
         </label>
         <Input
            className="ExchangeSettings__custom-token-input"
            value={value}
            onChange={e => setValue(e.target.value)}
            isDarkTheme={isDarkTheme}
         />
         <Button
            className="ExchangeSettings__custom-token-btn"
            variant="solid"
            color="primary"
            onClick={onAdd}
            size="lg"
            isDarkTheme={isDarkTheme}
         >
            Add Token
         </Button>
      </div>
   )
}

export default CustomToken
